import { CREATE_AFFILIATE_REQUEST, CREATE_AFFILIATE_REQUEST_SUCCESS, CREATE_AFFILIATE_REQUEST_FAILURE } from '../constants/create_affiliate.constants';

export const createAffiliateRequest = payload => ({
    type: CREATE_AFFILIATE_REQUEST, payload,
});

export const createAffiliateRequestSuccess = payload => ({
    type: CREATE_AFFILIATE_REQUEST_SUCCESS, payload,
});

export const createAffiliateRequestFailure = error => ({
    type: CREATE_AFFILIATE_REQUEST_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Manage_affiliates_create/redux/actions/create_affiliate.actions.js